module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-box"
  }, [_c('div', [_c('header', {
    staticClass: "w"
  }, [_c('div', {
    staticClass: "w-box"
  }, [_c('div', {
    staticClass: "nav-logo"
  }, [_c('h1', {
    on: {
      "click": function($event) {
        return _vm.changePage(-1)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "title": "成美生活商城"
    }
  }, [_vm._v("成美生活商城")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right-box"
  }, [_c('div', {
    staticClass: "nav-list"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品信息",
      "prefix-icon": "el-icon-search",
      "minlength": 1,
      "maxlength": 100,
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClick.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/goods"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.changePage(2)
      }
    }
  }, [_vm._v("全部商品")])])], 1), _vm._v(" "), _c('div', {
    ref: "aside",
    staticClass: "nav-aside",
    class: {
      fixed: _vm.st
    }
  }, [_c('div', {
    staticClass: "user pr"
  }, [_c('router-link', {
    attrs: {
      "to": "/user"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), (_vm.login) ? _c('div', {
    staticClass: "nav-user-wrapper pa"
  }, [_c('div', {
    staticClass: "nav-user-list"
  }, [_c('ul', [_c('li', {
    staticClass: "nav-user-avatar"
  }, [_c('div', [_c('span', {
    staticClass: "avatar",
    style: ({
      backgroundImage: 'url(' + _vm.userInfo.info.avatar + ')'
    })
  })]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userInfo.info.nickname))])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user/orderList"
    }
  }, [_vm._v("我的订单")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user/support"
    }
  }, [_vm._v("售后/退款")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user/prodCollect"
    }
  }, [_vm._v("我的收藏")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user/addressList"
    }
  }, [_vm._v("收货地址")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._loginOut
    }
  }, [_vm._v("退出")])])])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    ref: "positionMsg",
    staticClass: "shop pr",
    on: {
      "mouseover": function($event) {
        return _vm.cartShowState(true)
      },
      "mouseout": function($event) {
        return _vm.cartShowState(false)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/cart"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cart-num"
  }, [_c('i', {
    staticClass: "num",
    class: {
      no: _vm.totalNum <= 0,
      move_in_cart: _vm.receiveInCart
    }
  }, [_vm._v(_vm._s(_vm.totalNum))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCart),
      expression: "showCart"
    }],
    staticClass: "nav-user-wrapper pa active"
  }, [_c('div', {
    staticClass: "nav-user-list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalNum),
      expression: "totalNum"
    }],
    staticClass: "full"
  }, [_c('div', {
    staticClass: "nav-cart-items"
  }, [_c('ul', _vm._l((_vm.cartList), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "cart-item-inner"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.openProduct(item.productId)
        }
      }
    }, [_c('div', {
      staticClass: "item-thumb"
    }, [_c('img', {
      attrs: {
        "src": item.productImg
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-desc"
    }, [_c('div', {
      staticClass: "cart-cell"
    }, [_c('h4', [_c('a', {
      attrs: {
        "href": ""
      },
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    })]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#8d8d8d",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.sku))]), _vm._v(" "), _c('h6', [_c('span', {
      staticClass: "price-icon"
    }, [_vm._v("¥")]), _c('span', {
      staticClass: "price-num"
    }, [_vm._v(_vm._s(item.salePrice))]), _c('span', {
      staticClass: "item-num"
    }, [_vm._v("x " + _vm._s(item.productNum))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "del-btn del",
      on: {
        "click": function($event) {
          return _vm.delGoods(item.id, item.productId)
        }
      }
    }, [_vm._v("删除")])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "nav-cart-total"
  }, [_c('p', [_vm._v("共 "), _c('strong', [_vm._v(_vm._s(_vm.totalNum))]), _vm._v(" 件商品")]), _vm._v(" "), _c('h5', [_vm._v("合计："), _c('span', {
    staticClass: "price-icon"
  }, [_vm._v("¥")]), _c('span', {
    staticClass: "price-num"
  }, [_vm._v(_vm._s(_vm.totalPrice))])]), _vm._v(" "), _c('h6', [_c('y-button', {
    staticStyle: {
      "height": "40px",
      "width": "100%",
      "margin": "0",
      "color": "#fff",
      "font-size": "14px",
      "line-height": "38px"
    },
    attrs: {
      "classStyle": "main-btn",
      "text": "去购物车"
    },
    on: {
      "btnClick": _vm.toCart
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.totalNum),
      expression: "!totalNum"
    }],
    staticClass: "cart-con",
    staticStyle: {
      "height": "313px",
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您的购物车竟然是空的!")])])])])], 1)])])])]), _vm._v(" "), _vm._t("nav", function() {
    return [_c('div', {
      staticClass: "nav-sub",
      class: {
        fixed: _vm.st
      }
    }, [_c('div', {
      staticClass: "nav-sub-bg"
    }), _vm._v(" "), _c('div', {
      staticClass: "nav-sub-wrapper",
      class: {
        fixed: _vm.st
      }
    }, [_c('div', {
      staticClass: "w"
    }, [_c('ul', {
      staticClass: "nav-list2"
    }, [_c('li', [_c('router-link', {
      attrs: {
        "to": "/"
      }
    }, [_c('a', {
      class: {
        active: _vm.choosePage === -1
      },
      on: {
        "click": function($event) {
          return _vm.changGoods(-1)
        }
      }
    }, [_vm._v("首页")])])], 1), _vm._v(" "), _c('li', [_c('a', {
      class: {
        active: _vm.choosePage === -2
      },
      on: {
        "click": function($event) {
          return _vm.changGoods(-2)
        }
      }
    }, [_vm._v("全部")])]), _vm._v(" "), _vm._l((_vm.navList), function(item, i) {
      return _c('li', {
        key: i
      }, [_c('a', {
        class: {
          active: i === _vm.choosePage
        },
        on: {
          "click": function($event) {
            return _vm.changGoods(i, item)
          }
        }
      }, [_vm._v(_vm._s(item.picUrl))])])
    })], 2), _vm._v(" "), _c('div')])])])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e4ca828","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/header.vue
// module id = 295
// module chunks = 2 3 5 11 12 15